import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getGuest, getGuestReports, getGuestSlice } from "../../../services/getApi";
import { DELGuest } from "services/deleteApi";

const options = {
  weekday: 'long',
  month: 'numeric',
  day: 'numeric',
  year: "numeric"
};

function Reports({ change, setLoading }) {
  const [loading1, setLoading1] = useState(true);
  const [loading2, setLoading2] = useState(true);
  const [guests, setGuests] = useState([]);
  const [reports, setReport] = useState();
  const [searchTerm, setSearchTerm] = useState("");
  const [change2, setChange2] = useState(new Date());
  const navigate = useNavigate();

  useEffect(() => {
    setLoading1(true);
    setLoading(true);
    setLoading2(true);
    getGuestSlice(1).then(res => {
      setGuests(res.data || []);
      setLoading1(false);
      setLoading(false);
      getGuestReports().then(res2 => {
        setLoading2(false);
        setReport(res2.data);
      });
    });
  }, [change]);

  useEffect(() => {
    getGuestSlice(1).then(res => {
      setGuests(res.data || []);
      getGuestReports().then(res2 => {
        setReport(res2.data);
      });
    });
  }, [change2]);

  // فیلتر و جستجو
  const filteredGuests = guests.filter(guest => {
    const matchesSearch = 
      guest.fullname?.includes(searchTerm) ||
      guest.phone?.includes(searchTerm) ||
      guest.city?.includes(searchTerm) ||
      guest.number_room?.toString().includes(searchTerm);
    return matchesSearch;
  });

  return (
    <div className="p-4 page-ani">
      {/* Header */}
      <div className="flex items-center gap-3 mb-6">
        <div className="w-12 h-12 bg-gradient-to-br from-emerald-500 to-teal-600 rounded-xl flex items-center justify-center shadow-lg">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
          </svg>
        </div>
        <div>
          <h1 className="text-2xl font-bold text-white">گزارشات</h1>
          <p className="text-sm text-gray-400">آمار و اطلاعات مهمان‌ها</p>
        </div>
      </div>

      {/* Stats Cards */}
      {loading2 ? (
        <div className="flex justify-center py-10">
          <span className="loading loading-spinner loading-lg text-primary"></span>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
          {/* درآمد کل */}
          <div className="bg-gradient-to-br from-emerald-500/20 to-emerald-600/10 rounded-xl p-4 border border-emerald-500/30">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-400">درآمد کل</p>
                <p className="text-2xl font-bold text-white">
                  {reports?.totalPrice?.toLocaleString() || 0}
                </p>
                <p className="text-xs text-gray-500">تومان</p>
              </div>
              <div className="w-12 h-12 bg-emerald-500/20 rounded-lg flex items-center justify-center">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-emerald-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
            </div>
          </div>

          {/* میانگین درآمد */}
          <div className="bg-gradient-to-br from-blue-500/20 to-blue-600/10 rounded-xl p-4 border border-blue-500/30">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-400">میانگین درآمد</p>
                <p className="text-2xl font-bold text-white">
                  {reports?.mean?.toLocaleString() || 0}
                </p>
                <p className="text-xs text-gray-500">تومان</p>
              </div>
              <div className="w-12 h-12 bg-blue-500/20 rounded-lg flex items-center justify-center">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-blue-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 12l3-3 3 3 4-4M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z" />
                </svg>
              </div>
            </div>
          </div>

          {/* تعداد کل مهمانان */}
          <div className="bg-gradient-to-br from-rose-500/20 to-rose-600/10 rounded-xl p-4 border border-rose-500/30">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-400">تعداد کل مهمانان</p>
                <p className="text-2xl font-bold text-white">
                  {reports?.orderTotal || 0}
                </p>
                <p className="text-xs text-gray-500">نفر</p>
              </div>
              <div className="w-12 h-12 bg-rose-500/20 rounded-lg flex items-center justify-center">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-rose-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
              </div>
            </div>
          </div>

          {/* درآمد ماه */}
          <div className="bg-gradient-to-br from-purple-500/20 to-purple-600/10 rounded-xl p-4 border border-purple-500/30">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-400">درآمد این ماه</p>
                <p className="text-2xl font-bold text-white">
                  {reports?.priceMonth?.toLocaleString() || 0}
                </p>
                <p className="text-xs text-gray-500">تومان</p>
              </div>
              <div className="w-12 h-12 bg-purple-500/20 rounded-lg flex items-center justify-center">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-purple-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
              </div>
            </div>
          </div>

          {/* مهمانان ماه */}
          <div className="bg-gradient-to-br from-amber-500/20 to-amber-600/10 rounded-xl p-4 border border-amber-500/30">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-400">مهمانان این ماه</p>
                <p className="text-2xl font-bold text-white">
                  {reports?.orderMonth || 0}
                </p>
                <p className="text-xs text-gray-500">نفر</p>
              </div>
              <div className="w-12 h-12 bg-amber-500/20 rounded-lg flex items-center justify-center">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-amber-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
                </svg>
              </div>
            </div>
          </div>

          {/* درآمد هفته */}
          <div className="bg-gradient-to-br from-cyan-500/20 to-cyan-600/10 rounded-xl p-4 border border-cyan-500/30">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-400">درآمد این هفته</p>
                <p className="text-2xl font-bold text-white">
                  {reports?.weekMonth?.toLocaleString() || 0}
                </p>
                <p className="text-xs text-gray-500">تومان</p>
              </div>
              <div className="w-12 h-12 bg-cyan-500/20 rounded-lg flex items-center justify-center">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-cyan-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
            </div>
          </div>

          {/* مهمانان هفته */}
          <div className="bg-gradient-to-br from-pink-500/20 to-pink-600/10 rounded-xl p-4 border border-pink-500/30">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-400">مهمانان این هفته</p>
                <p className="text-2xl font-bold text-white">
                  {reports?.orderWeek || 0}
                </p>
                <p className="text-xs text-gray-500">نفر</p>
              </div>
              <div className="w-12 h-12 bg-pink-500/20 rounded-lg flex items-center justify-center">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-pink-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
              </div>
            </div>
          </div>

          {/* میانگین اقامت */}
          <div className="bg-gradient-to-br from-indigo-500/20 to-indigo-600/10 rounded-xl p-4 border border-indigo-500/30">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-400">میانگین اقامت</p>
                <p className="text-2xl font-bold text-white">
                  {reports?.avgStay || 0}
                </p>
                <p className="text-xs text-gray-500">روز</p>
              </div>
              <div className="w-12 h-12 bg-indigo-500/20 rounded-lg flex items-center justify-center">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-indigo-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                </svg>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Search */}
      <div className="flex flex-col md:flex-row gap-4 mb-6">
        <div className="flex-1">
          <div className="relative">
            <input
              type="text"
              placeholder="جستجو بر اساس نام، تلفن، شهر یا شماره اتاق..."
              className="input input-bordered w-full bg-base-200/50 pr-10"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 absolute right-3 top-1/2 -translate-y-1/2 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
          </div>
        </div>
      </div>

      {/* Table */}
      {loading1 ? (
        <div className="flex justify-center py-20">
          <span className="loading loading-spinner loading-lg text-primary"></span>
        </div>
      ) : (
        <div className="bg-base-300/50 rounded-xl shadow-xl overflow-hidden">
          <div className="overflow-x-auto">
            <table className="table w-full">
              <thead>
                <tr className="bg-base-200/50">
                  <th className="text-right">نام کامل</th>
                  <th className="text-center">اتاق</th>
                  <th className="text-center">شهر</th>
                  <th className="text-center">تلفن</th>
                  <th className="text-center">ورود</th>
                  <th className="text-center">خروج</th>
                  <th className="text-center">اقامت</th>
                  <th className="text-center">قیمت اتاق</th>
                  <th className="text-center">تخفیف</th>
                  <th className="text-center">قیمت نهایی</th>
                  <th className="text-center">عملیات</th>
                </tr>
              </thead>
              <tbody>
                {filteredGuests.length === 0 ? (
                  <tr>
                    <td colSpan="11" className="text-center py-10">
                      <div className="flex flex-col items-center gap-3">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                        </svg>
                        <p className="text-gray-400">هیچ داده‌ای یافت نشد</p>
                      </div>
                    </td>
                  </tr>
                ) : (
                  filteredGuests.map((guest, index) => (
                    <ReportRow 
                      key={guest._id} 
                      guest={guest} 
                      index={index}
                      options={options}
                      onRefresh={() => setChange2(new Date())}
                    />
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Show More Button */}
      {!loading1 && guests.length > 0 && (
        <div className="flex justify-center mt-6">
          <button 
            className="btn btn-primary btn-outline gap-2"
            onClick={() => navigate('/guests')}
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
            </svg>
            نمایش همه مهمان‌ها
          </button>
        </div>
      )}
    </div>
  );
}

function ReportRow({ guest, index, options, onRefresh }) {
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const navigate = useNavigate();

  const handleDelete = () => {
    if (showDeleteConfirm) {
      DELGuest(guest._id)
        .then(() => onRefresh())
        .catch(err => console.error(err));
    } else {
      setShowDeleteConfirm(true);
      setTimeout(() => setShowDeleteConfirm(false), 3000);
    }
  };

  return (
    <tr className={`hover:bg-base-200/50 transition-colors ${index % 2 === 0 ? 'bg-base-100/30' : ''}`}>
      <td className="text-right">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-gradient-to-br from-emerald-500/30 to-teal-500/30 rounded-lg flex items-center justify-center">
            <span className="text-white font-bold">{guest.fullname?.charAt(0) || '-'}</span>
          </div>
          <div>
            <p className="font-medium text-white">{guest.fullname || '-'}</p>
            <p className="text-xs text-gray-400">{new Date(guest.createdAt).toLocaleDateString('fa-IR', options)}</p>
          </div>
        </div>
      </td>
      <td className="text-center">
        <span className="badge badge-lg bg-base-200">{guest.number_room || '-'}</span>
      </td>
      <td className="text-center text-gray-300">{guest.city || '-'}</td>
      <td className="text-center text-gray-300" dir="ltr">{guest.phone || '-'}</td>
      <td className="text-center text-gray-300">{guest.login_date || '-'}</td>
      <td className="text-center text-gray-300">{guest.logout_date || '-'}</td>
      <td className="text-center">
        <span className="badge badge-primary">{guest.stay_time || 0} روز</span>
      </td>
      <td className="text-center">
        <span className="text-white font-medium">{guest.roomPrice?.toLocaleString() || guest.price?.toLocaleString() || 0}</span>
        <span className="text-xs text-gray-400 mr-1">تومان</span>
      </td>
      <td className="text-center">
        <span className="badge badge-ghost">{guest.discount || 0}٪</span>
      </td>
      <td className="text-center">
        <span className="text-white font-bold">{guest.finalPrice?.toLocaleString() || guest.price?.toLocaleString() || 0}</span>
        <span className="text-xs text-gray-400 mr-1">تومان</span>
      </td>
      <td className="text-center sticky left-0">
        <div className="flex items-center justify-center gap-1">
          <button 
            className="btn btn-ghost btn-sm"
            onClick={() => navigate(`/print/${guest._id}`)}
            title="چاپ"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-info" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z" />
            </svg>
          </button>
          <button 
            className={`btn btn-ghost btn-sm ${showDeleteConfirm ? 'btn-error' : ''}`}
            onClick={handleDelete}
            title={showDeleteConfirm ? "تایید حذف" : "حذف"}
          >
            {showDeleteConfirm ? (
              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-error" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            ) : (
              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-error" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
              </svg>
            )}
          </button>
        </div>
      </td>
    </tr>
  );
}

export default Reports;
